export default "__VITE_ASSET__20e30c45__"